import { Injectable } from '@angular/core';
import { GEO_TARGETING_TYPE_KEY, GeoType, GeoTypeState } from './geo-type.reducer';
import { map, filter, distinctUntilChanged } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { GeoTypeActions } from './geo-type.actions';
import { GEO_TARGETING_STATE_KEY, GeoState } from '../geo.reducer';
import { GeoIdService } from '../geo.id';
import { AppState } from '../../reducers/index';

@Injectable()
export class GeoTypeService {
  getModel = (_store): Observable<GeoTypeState> => {
    return _store.select(GEO_TARGETING_STATE_KEY)
                 .pipe(
                   map((geo) => {
                     const id = this.geoIdService.id$.getValue();
                     return geo[id];
                   }),
                   filter((geoState: GeoState) => Boolean(geoState)),
                   map((geoState: GeoState) => {
                     return geoState[GEO_TARGETING_TYPE_KEY];
                   }),
                   distinctUntilChanged()
                 );
  }

  setTranslatedSearchType () {
    this._store.dispatch(this.geoTypeActions.setTranslatedSearchType());
  }

  selectSearchType (selectedType: GeoType) {
    this._store.dispatch(this.geoTypeActions.selectSearchType(selectedType));
  }

  toggleSearchTypeDropdown (isOpen: boolean) {
    this._store.dispatch(this.geoTypeActions.toggleSearchTypeDropdown(isOpen));
  }

  constructor (private _store: Store<AppState>,
               private geoIdService: GeoIdService,
               private geoTypeActions: GeoTypeActions) {}
}
